import React from 'react'
import classnames from 'classnames';

const EmptyCard = (props) => {
  const Icon = props.icon
  return (
    <div className={classnames(props?.className)}>
      <div className="flex justify-center mb-4">
        <Icon size={84} color={props?.iconColor ?? "#0F1F77"}/>
      </div>
      <h6 className="text-xl text-neutral-600 text-center mb-4">{props?.label}</h6>
      {props?.text && <p className="text-neutral-600">{props.text}</p>}
      {props?.children && <>{props.children}</>}
    </div>
  )
}

export default EmptyCard